// extracted by mini-css-extract-plugin
export default {"nft-preview":"style_nft-preview__tdP1H","msg-wrapper":"style_msg-wrapper__nfljn","price":"style_price__8+WsD"};